import ReactTooltip from 'react-tooltip';
import Icon from '../../../../Icon/Icon';

function UploadCard({ fileCount, title, tooltipText, processing, supportedFiles }) {

    return (
        <div className="flex-1">
            <div className="module">
                <div className="font-light text-xs">
                    <span className="uppercase mr-2">
                        {title}
                    </span>
                    <span>
                        <ReactTooltip
                            effect="solid"
                            className="w-48 p-2"
                            id="impacts"
                            aria-haspopup="true">
                            {tooltipText}
                        </ReactTooltip>
                        <a data-tip data-for="impacts">
                            <Icon
                                name="info-circle"
                                className="text-gray-700 text-sm"
                            />
                        </a>
                    </span>
                </div>
                <div className="font-semibold text-2xl">
                    {fileCount ? fileCount : '0'}
                </div>
                <div className="currentStatus flex justify-between">
                    <div
                        className="text-xs mt-2 text-gray-400"
                    >
                        {supportedFiles}
                    </div>
                    <div
                        className="mt-2 text-blue-400"
                        style={{ fontSize: '50%' }}>
                        <span
                            style={{ fontSize: '40%' }}
                            className="text-sm font-thin text-gray-500">
                        </span>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default UploadCard;



